import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const getDomainData = createAsyncThunk('getDomain/getDomainData', async () => {
  const role = localStorage.getItem('role');
  const fqdn = localStorage.getItem('domain');
  const response = await axios.get(`GetADDetails/getdomain?role=${role}&FQDN=${fqdn}`);
  return { status: response.status, data: response.data };
});

export const getDomainList = createAsyncThunk('getDomain/getDomainList', async (value) => {
  const response = await axios.get(`DomainList?Url=${value}`);
  return response.data;
});

export const createDomain = createAsyncThunk('domainSlice/createdomain', async (values) => {
  try {
    const response = await axios.post(`GetADDetails/createdomain`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});

export const updateDomain = createAsyncThunk('domainSlice/updateDomain', async (updateDomainData) => {
  try {
    const response = await axios.put(`GetADDetails/updatedomain?Id=${updateDomainData.id}`, updateDomainData.values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});

//Update the PrimaryDomain
export const updatePrimaryDomain = createAsyncThunk('domainSlice/updatePrimaryDomain', async (data) => {
  try {
    const response = await axios.post(`GetADDetails/updateprimarydomain?Id=${data.id}`, data.values);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

//Get Single DomainData Uisng Domain Id
export const getSingleDomain = createAsyncThunk('domainSlice/SingleDomain', async (id) => {
  const response = await axios.get(`GetADDetails/getdomainbyid/${id}`);
  return { status: response.status, data: response.data };
});

export const deleteDomain = createAsyncThunk('DeleteDomain/DeleteDomainList', async (id) => {
  try {
    const response = await axios.delete(`GetADDetails/DeleteDomain?id=${id}`);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});
// Utility function to convert array to object
const arrayToObject = (data) => {
  if (!data) {
    return null;
  } else {
    let domainfromApi = [];

    // Check if the data is an array
    if (Array.isArray(data)) {
      domainfromApi = data.map((item) => ({
        id: item.id,
        name: item.fqdn,
        dnName: item.distinguishedName,
        isPrimary: item.isPrimaryDomain,
      }));
      domainfromApi.sort((a, b) => b.isPrimary - a.isPrimary);
    } else {
      // If data is not an array, handle it as a single object
      domainfromApi.push({
        id: data.id,
        name: data.fqdn,
        dnName: data.distinguishedName,
      });
    }

    return domainfromApi;
  }
};
const initialState = {
  data: [],
  domainList: [],
  domainObject: [],
  domainFromApi: [],
  loading: false,
  error: null,
};

const domainDataSlice = createSlice({
  name: 'domainData',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getDomainData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDomainData.fulfilled, (state, action) => {
        state.loading = false;
        state.domainFromApi = action.payload.data;
        state.domainObject = arrayToObject(action.payload.data);
        state.error = null;
      })
      .addCase(getDomainData.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.error.message;
      })
      .addCase(getDomainList.fulfilled, (state, action) => {
        state.loading = false;
        state.domainList = action.payload;
        state.error = null;
      });
  },
});

export default domainDataSlice.reducer;
